import { createFileRoute } from '@tanstack/react-router'
import Wallet from '@/features/wallet/views'

export const Route = createFileRoute('/wallet')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Wallet />
}
